export const environment = {
  baseUrl: 'https://dev.finance360.t-systems.net',
  agentUrl: 'https://dev.finance360.t-systems.net',
  billingUrl: 'https://dev.finance360.t-systems.net',
  name: 'development',
  useMsal: true,
  msalConfig: {
    auth: {
      clientId: '133f8d5e-6232-40d7-9b6c-357c494fe6d9',
      authority: 'https://login.microsoftonline.com/a5e6c6bd-17f0-4980-be25-49bcd5c558ae',
    },
    apiConfig: {
      scopes: ['api://finance360-api/roles'],
      uri: 'https://dev.finance360.t-systems.net',
    },
  },
};
